import { jsx as e } from "react/jsx-runtime";
function i(l) {
  return /* @__PURE__ */ e("svg", { height: "50", viewBox: "0 0 50 50", width: "50", ...l, children: /* @__PURE__ */ e("g", { children: /* @__PURE__ */ e(
    "path",
    {
      clipRule: "evenodd",
      d: "M32.9443 15.7872L30.3715 15.7881C28.3545 15.7881 27.9635 16.7469 27.9635 18.1535V21.2556H32.7745L32.7731 26.1147H27.9635V38.5828H22.9456V26.1147H18.75V21.2556H22.9456V17.6727C22.9456 13.5147 25.4854 11.25 29.1952 11.25L32.9443 11.256V15.7872Z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ) }) });
}
export {
  i as default
};
